import { Capacitor } from "@capacitor/core";

/**
 * Delay before scrolling an input into view after focus.
 * Matches each platform's software keyboard animation duration,
 * ensuring the viewport has finished resizing before we scroll.
 */
export const ANDROID_KEYBOARD_DELAY_MS = 300;
export const IOS_KEYBOARD_DELAY_MS = 500;

/**
 * Scrolls an element into view after the keyboard animation completes.
 * Call this inside a focus handler for inputs rendered in native webviews.
 */
export function scrollIntoViewAfterKeyboard(el: HTMLElement | null | undefined) {
  const delay =
    Capacitor.getPlatform() === "android" ? ANDROID_KEYBOARD_DELAY_MS : IOS_KEYBOARD_DELAY_MS;
  setTimeout(() => el?.scrollIntoView({ behavior: "smooth", block: "center" }), delay);
}
